<template>
  <div class="page-header">
    <div class="page-header__left">
      <div class="page-header__icon" :style="{ background: iconBg }">
        <i :class="icon"></i>
      </div>
      <div>
        <h1 class="page-title">{{ title }}</h1>
        <p class="page-subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div class="page-header__actions">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CrmPageHeader',
  props: {
    title:    { type: String, required: true },
    subtitle: { type: String, default: '' },
    icon:     { type: String, default: 'fas fa-circle' },
    iconBg:   { type: String, default: 'linear-gradient(135deg,#1E3A5F,#2563EB)' },
  },
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
}

.page-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.page-header__icon {
  width: 44px;
  height: 44px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1rem;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(37,99,235,0.2);
}

.page-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1E293B;
  margin: 0 0 2px;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 0.75rem;
  color: #94A3B8;
  margin: 0;
}

.page-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
